module.exports = __webpack_public_path__ + "static/media/Preview_Android_Notification.07a0aab8.png";